import React from "react";
import { Card } from "react-bootstrap";
import { Trans } from "react-i18next";

export default function NotFound() {
    return (
        <Card>
            <Card.Body>
                <Trans>Страница не найдена</Trans>
            </Card.Body>
        </Card>
    );
}
